import Vue from 'vue'

const SmoothAppear = {
  // hook
  async inserted (el, binding) {
    const { styler, timeline, easing } = Vue.popmotion
    let elements = SmoothAppear.getElements(el, binding)
    let items = Array.from(elements).map(styler)
    let labels = items.map((s, i) => 'smooth-appear-' + i)
    const tweenUp = (track, duration, yFrom) => ({
      track,
      duration,
      from: { y: yFrom, opacity: 0 },
      to: { y: 0, opacity: 1 },
      ease: { y: easing.backOut, opacity: easing.linear }
    })
    const setStylers = (v) => {
      labels.forEach((label, i) => {
        if (v[label] !== undefined) items[i].set(v[label])
      })
    }
    timeline([
      binding.value.wait || 0,
      [...items.map((s, i) => tweenUp(
        labels[i], binding.value.duration || 700,
        binding.value.translate || 50
      )), binding.value.delay || 30]
    ]).start({
      update: setStylers,
      complete () {
        items.forEach(item => {
          item.set({y: undefined, opacity: undefined})
        })
      }
    })
  },
  getElements (el, binding) {
    let v = binding.value.elements
    if (!v) {
      return el.childNodes()
    }
    if (typeof v === 'string') {
      return el.querySelectorAll(v)
    }
    return v
  }
}

export default SmoothAppear



// WEBPACK FOOTER //
// ./src/directives/SmoothAppear.js